// NPM Imports
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Loader, Toastr, Tooltip, Button } from "@revvsales/components";

// Components Imports
import TitleBar from "../../TitleBar";

// Components Imports
import AssetFolder from "./AssetFolder";
import CreateAssetFolderPopup from "./CreateAssetFolderPopup";

// Actions Imports
import {
  getAssetFolderTreeAction,
  toggleAssetDocumentView,
} from "../../../actions/AssetActions/assetActions";

// Methods Imports
import { checkAssetPermission } from "../method";

// Internal Imports
import { GlobalUtils } from "../../../utils";
import { ASSET } from "../../../constants";

// Destructuring
const { handleApiErrMsg } = GlobalUtils;
const { ASSET_PAGE_URL } = ASSET;

class AssetLeftSection extends Component {
  state = {
    showAssetCreateFolderPopup: false,
    showNormalFolderList: true,
    showCRMFolderList: true,
    showLoader: false,
  };

  componentDidMount() {
    this.setState({ showLoader: true });
    this.props
      .getAssetFolderTreeAction()
      .then(() => {
        this.setState({ showLoader: false });
      })
      .catch(error => {
        console.debug(
          `Asset => getAssetFolderTree => _onInitAssets => Error : ${error}`,
        );
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
        this.setState({ showLoader: false });
      });
  }

  _toggleCreateAssetFolderPopup = flag => {
    this.setState({ showAssetCreateFolderPopup: flag });
  };

  _toggleAssetDocumentView = view => {
    this.props.toggleAssetDocumentView(view);
  };

  // Get the Folders in a Tree format
  _getFoldersTree = foldersArray => {
    if (foldersArray && foldersArray.length > 0) {
      return foldersArray.map(folder => {
        const { assetFolderContent } = this.props;
        const { id: folderID, children } = folder;
        let findSubFolderInParentFolder;

        // Get the current selected folder's parent path name &
        // match it with the all folder's name
        if (
          folderID !== undefined &&
          children &&
          children.length > 0 &&
          assetFolderContent &&
          assetFolderContent.page &&
          assetFolderContent.page.path
        ) {
          const currentSelectedFolderParentPath = assetFolderContent.page.path;
          const currentSelectedFolderParentNameArray = currentSelectedFolderParentPath
            ? currentSelectedFolderParentPath.split("/")
            : [];
          findSubFolderInParentFolder = currentSelectedFolderParentNameArray.find(
            fId => fId === String(folderID),
          );
        }

        /**
         * Check if the "subFolders" are present inside the root "folder" then,
         * use recursion concept to get the tree of all nested "subFolders"
         */
        const rootFolders = this._getAssetFolder(
          folder,
          findSubFolderInParentFolder,
        );
        if (!folder.isCRMFolder && findSubFolderInParentFolder) {
          return (
            <div className="assetleftsection-folder-wrapper" key={folder.id}>
              {rootFolders}
              <div className="assetleftsection-subfolder-wrapper">
                {this._getFoldersTree(children)}
              </div>
            </div>
          );
        }
        return (
          <div className="assetleftsection-folder-wrapper" key={folder.id}>
            {rootFolders}
          </div>
        );
      });
    }
    return null;
  };

  // Get the AssetFolder Item
  _getAssetFolder = (folder, isFolderOpen) => (
    <AssetFolder
      folder={folder}
      selectedFolderId={this.props.folderID}
      isFolderOpen={isFolderOpen}
      history={this.props.history}
    />
  );

  _toogleFolderList = (type, flag) => {
    this.setState({ [type]: flag });
  };

  _stopEventPropogation = event => {
    event.preventDefault();
    event.stopPropagation();
  };

  render() {
    const {
      folderID,
      assetFoldersTree,
      currentSelectedFolder,
      currentView,
    } = this.props;
    const {
      showAssetCreateFolderPopup,
      showNormalFolderList,
      showCRMFolderList,
    } = this.state;
    let folderIconType = "fal";
    if (currentView === "my-documents" && !folderID) {
      folderIconType = "fas";
    }

    let createFolderPopup = null;
    if (showAssetCreateFolderPopup) {
      createFolderPopup = (
        <CreateAssetFolderPopup
          show={showAssetCreateFolderPopup}
          closePopup={this._toggleCreateAssetFolderPopup}
          associatedFolderId={folderID}
          history={this.props.history}
        />
      );
    }
    let hasCreatePermission = true;
    if (currentSelectedFolder) {
      const { id, accessLevel } = currentSelectedFolder;
      if (id !== null) {
        hasCreatePermission = checkAssetPermission(accessLevel);
      }
    }

    let crmFolderList = (
      <div className="assetleftsection-empty-folders">
        Integrate with CRM to view your opportunities as folders.{" "}
        <a
          href={`${
            process.env.REACT_APP_HELP_JUICE_URL
          }/docs/integration-with-your-current-crm`}
          target="blank"
          data-test="assetsleftsection-learnmore-link">
          Learn More
        </a>
      </div>
    );

    if (
      assetFoldersTree &&
      assetFoldersTree.crmFoldersTree &&
      assetFoldersTree.crmFoldersTree.length > 0
    ) {
      crmFolderList = this._getFoldersTree(assetFoldersTree.crmFoldersTree);
    }

    return (
      <div className="assetleftsection-container">
        {createFolderPopup}
        <div className="assetleftsection-scrollable">
          <div className="assetleftsection-titlebar-wrapper">
            <TitleBar
              iconName="folders"
              title="Documents"
              subTitle="All your documents"
            />
          </div>
          <div className="assetleftsection-scroll">
            {/* ----------------- All Folders Link Section ----------------- */}
            <div className="assetleftsection-title top-title">
              <span
                className={`assetleftsection-allfolder-title assetleftsection-allfolder-link ${
                  !folderID && currentView === "all" ? "active-link" : ""
                }`}>
                <Tooltip
                  placement="right"
                  overlay="Find all documents and folders you own or shared with you here">
                  <Link
                    to={`/${ASSET_PAGE_URL}`}
                    onClick={() => this._toggleAssetDocumentView("all")}>
                    <FontAwesomeIcon
                      icon={["fal", "border-all"]}
                      className="allfolder-icon show-hover"
                    />
                    <FontAwesomeIcon
                      icon={["fas", "border-all"]}
                      className="allfolder-icon hide-hover"
                    />{" "}
                    All
                  </Link>
                </Tooltip>
              </span>
              <span
                className={`assetleftsection-allfolder-title assetleftsection-allfolder-link ${
                  !folderID && currentView === "my-documents"
                    ? "active-link"
                    : ""
                }`}>
                <Tooltip
                  placement="right"
                  overlay="Find only your documents listed here">
                  <Link
                    to={`/${ASSET_PAGE_URL}`}
                    onClick={() =>
                      this._toggleAssetDocumentView("my-documents")
                    }>
                    <FontAwesomeIcon
                      icon={[`${folderIconType}`, "file"]}
                      className="allfolder-icon show-hover"
                    />
                    <FontAwesomeIcon
                      icon={["fas", "file"]}
                      className="allfolder-icon hide-hover"
                    />{" "}
                    My documents
                  </Link>
                </Tooltip>
              </span>

              {/* <div
                className="assetleftsection-createfolder-wrapper"
                onClick={this._stopEventPropogation}
                onKeyPress={() => {}}
                role="button"
                tabIndex="0">
                <Tooltip
                  placement="top"
                  overlay="Create new folder"
                  align={{
                    offset: [0, 6],
                  }}>
                  <Button
                    className="revv-btn-secondary asset-createfolder-btn"
                    onClick={() => this._toggleCreateAssetFolderPopup(true)}>
                    <i className="plusiconadd">
                      <FontAwesomeIcon icon={["far", "plus"]} />
                    </i>
                  </Button>
                </Tooltip>
              </div> */}
            </div>
            {!this.state.showLoader && (
              <div className="assetleftsection-folderlist-wrapper">
                {/* ----------------- Normal Folders Tree Section ----------------- */}
                <div
                  className="assetleftsection-title-wrapper"
                  onClick={() =>
                    this._toogleFolderList(
                      "showNormalFolderList",
                      !showNormalFolderList,
                    )
                  }
                  onKeyPress={() => {}}
                  role="button"
                  tabIndex="0">
                  <div className="assetleftsection-folder-title">Folders</div>
                  {/* ----------------- Create New Folder Section ----------------- */}
                  <div
                    className="assetleftsection-createfolder-wrapper"
                    onClick={this._stopEventPropogation}
                    onKeyPress={() => {}}
                    role="button"
                    tabIndex="0">
                    {hasCreatePermission ? (
                      <Button
                        className="revv-btn-secondary asset-createfolder-btn"
                        onClick={() => this._toggleCreateAssetFolderPopup(true)}
                        data-test="assetsleftsection-add-new-btn">
                        Add new
                      </Button>
                    ) : (
                      <Button
                        className="revv-btn-secondary asset-createfolder-btn disabled-btn "
                        onClick={() => {}}
                        data-test="assetsleftsection-add-btn">
                        Add new
                      </Button>
                    )}
                  </div>
                  <div className="assetleftsection-folder-arrow">
                    {showNormalFolderList ? (
                      <FontAwesomeIcon
                        icon={["far", "angle-up"]}
                        className="ic-toggle"
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={["far", "angle-down"]}
                        className="ic-toggle"
                      />
                    )}
                  </div>
                </div>
                <div
                  className={`assetleftsection-folder-container normal-folder-container ${
                    !showNormalFolderList ? "hide-list" : ""
                  } `}>
                  {this._getFoldersTree(
                    assetFoldersTree ? assetFoldersTree.normalFoldersTree : [],
                  )}
                </div>

                {/* ----------------- CRM Folders Tree Section ----------------- */}
                <div
                  className="assetleftsection-title-wrapper assetleftsection-title"
                  onClick={() =>
                    this._toogleFolderList(
                      "showCRMFolderList",
                      !showCRMFolderList,
                    )
                  }
                  onKeyPress={() => {}}
                  role="button"
                  tabIndex="0">
                  <span className="assetleftsection-folder-title">
                    Linked Folders
                  </span>
                  <Tooltip
                    placement="top"
                    overlay="Each folder represents an opportunity synced from your CRM and contains files of that opportunity only."
                    align={{
                      offset: [0, 6],
                    }}>
                    <span className="whats-this">
                      <i>
                        <FontAwesomeIcon icon={["far", "info-circle"]} />
                      </i>
                    </span>
                  </Tooltip>
                  <div className="assetleftsection-folder-arrow">
                    {showCRMFolderList ? (
                      <FontAwesomeIcon
                        icon={["far", "angle-up"]}
                        className="ic-toggle"
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={["far", "angle-down"]}
                        className="ic-toggle"
                      />
                    )}
                  </div>
                </div>

                <div
                  className={`assetleftsection-folder-container crm-folder-container ${
                    !showCRMFolderList ? "hide-list" : ""
                  } `}>
                  {crmFolderList}
                </div>
              </div>
            )}
          </div>
          {/* Add loader will be here */}
          {this.state.showLoader && (
            <div className="assetleftsection-loader-wrapper">
              <Loader className="loader-bg-color" label="loading..." />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    assetFoldersTree,
    assetFolderContent,
    currentSelectedFolder,
    currentView,
  } = state.AssetStore;
  return {
    assetFoldersTree,
    assetFolderContent,
    currentSelectedFolder,
    currentView,
  };
};

const mapDispatchToProps = {
  getAssetFolderTreeAction,
  toggleAssetDocumentView,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssetLeftSection);



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetLeftSection/index.js